module.exports = __webpack_public_path__ + "assets/img/introduction_profile.24dbcb66.png";